import Navbar from '@/components/funnel28/homepage/Navbar';
import HeroSection from '@/components/funnel28/landing/HeroSection';
import { FeaturesSection } from '@/components/funnel28/landing/FeaturesSection';
import BenefitsSection from '@/components/funnel28/landing/BenefitsSection';
import FooterSection from '@/components/funnel28/landing/FooterSection';
import { TestimonialsLanding } from '@/components/funnel28/landing/TestimonialsLanding';
import ProofSection from '@/components/funnel28/landing/ProofSection';
import GoToQuizButton from '@/components/funnel28/landing/GoToQuizButton';
import GoToCheckoutButton from '@/components/funnel28/landing/GoToCheckoutButton';

const MomApplyHome = () => {
  return (
    <div className="w-full overflow-hidden">
      <Navbar showNavigation={false} showSignIn={true} showGetStarted={false} customNavItems={undefined} />
      <main id="main-content">
      <HeroSection />
      <BenefitsSection />
      <FeaturesSection
        buttons={
          <div className="flex justify-center px-4 w-full flex-col md:flex-row gap-4">
            <GoToQuizButton className="w-full sm:w-auto" funnelId={28} />
            <GoToCheckoutButton className="w-full sm:w-auto" funnelId={28} />
          </div>
        }
      />
      <TestimonialsLanding />
      <ProofSection />
      <FooterSection />
      </main>
    </div>
  );
};

export default MomApplyHome;
